import { render, staticRenderFns } from "./TextareaComponent.vue?vue&type=template&id=a415f608"
import script from "./TextareaComponent.vue?vue&type=script&lang=ts"
export * from "./TextareaComponent.vue?vue&type=script&lang=ts"
import style0 from "./TextareaComponent.vue?vue&type=style&index=0&id=a415f608&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports